export const TOAST_LIFETIME = 8000;
export const FULL_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const SHORT_DATE_FORMAT = 'yyyy-MM-dd';
